import React from "react";
import { Card, Button, ListGroup } from "react-bootstrap";
import { QRCodeSVG as QRCode } from "qrcode.react";
import { Download } from "react-feather";
import defaultConfig from "./config";
const QRPreview = ({
  qrCodeSettings,
  surveyLink,
  isDownloadOpen,
  setIsDownloadOpen,
  downloadQRPDF,
  downloadQRPNG,
  qrTitle,
  qrTitleColor,
  qrTitleSize,
  qrDesc,
  qrDescColor,
  qrDescSize,
  headerLogo,
  borderGradientStart,
  borderGradientEnd,
  headerLogoWidth,
  headerLogoHeight,
  showHeaderLogo,   // ✅ new prop
  headerLogoUrl,    // ✅ new prop
}) => {
  const companyLogo = localStorage.getItem("companylogo");
  const logoNetShine = companyLogo && companyLogo.trim()
    ? `${defaultConfig.cdnUrl}/${companyLogo}`
    : 'https://netshine-assets.blr1.digitaloceanspaces.com/company_87/logos/company_logo_87_1739613280498';
  const defaultLogoSrc = companyLogo && companyLogo.trim()
    ? `${defaultConfig.cdnUrl}/${companyLogo}`
    : logoNetShine;
  // Match PDF page: 6×8 inches ≈ 15.24 × 20.32 cm
  const pageWcm = 15.24;
  const pageHcm = 20.32;
  const qrSizeCm = 6;
  return (
    <Card
      style={{
        width: `${pageWcm}cm`,
        height: `${pageHcm}cm`,
        border: "4px solid transparent",
        borderImage: `linear-gradient(45deg, ${borderGradientStart}, ${borderGradientEnd}) 1`,
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
      }}
    >
      <Card.Header style={{ background: "transparent", border: "none", padding: "0.5cm" }}>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="link"
            onClick={() => setIsDownloadOpen(!isDownloadOpen)}
            aria-label="Download QR Code"
            style={{ padding: 0 }}
          >
            <Download size={20} color="#007bff" />
          </Button>
          {isDownloadOpen && (
            <ListGroup
              className="position-absolute"
              style={{
                zIndex: 5,
                width: "150px",
                right: "0.5cm",
                top: "1.5cm",
              }}
            >
              <ListGroup.Item
                action
                onClick={() => {
                  downloadQRPDF(
                    qrTitle,
                    qrTitleColor,
                    qrTitleSize,
                    qrDesc,
                    qrDescColor,
                    qrDescSize,
                    headerLogo || defaultLogoSrc,   // ✅ logo url
                    headerLogoWidth,
                    headerLogoHeight,
                    qrCodeSettings.showHolderLogo,  // ✅ show header logo
                    borderGradientStart,            // ✅ added
                    borderGradientEnd               // ✅ added
                  );
                  setIsDownloadOpen(false);
                }}
              >
                PDF
              </ListGroup.Item>
              <ListGroup.Item
                action
                onClick={() => {
                  downloadQRPNG(
                    qrTitle,
                    qrTitleColor,
                    qrTitleSize,
                    qrDesc,
                    qrDescColor,
                    qrDescSize,
                    headerLogo || defaultLogoSrc,
                    headerLogoWidth,
                    headerLogoHeight
                  );
                  setIsDownloadOpen(false);
                }}
              >
                PNG
              </ListGroup.Item>
            </ListGroup>
          )}
        </div>
      </Card.Header>
      <Card.Body
        style={{
          padding: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1,
        }}
      >
        {/* Header logo */}
        {qrCodeSettings.showHolderLogo && (
          <div style={{ textAlign: "center", marginTop: "1cm" }}>
            <img
              src={headerLogo || defaultLogoSrc}
              alt="Header Logo"
              style={{
                height: `${qrCodeSettings.headerLogoHeight || 40}px`,
                width: `${qrCodeSettings.headerLogoWidth || 100}px`,
                marginBottom: "0.6cm"
              }}
            />
          </div>
        )}
        {/* Title + Description */}
        <div style={{ textAlign: "center", padding: "0 1cm" }}>
          {qrTitle && (
            <h4
              style={{
                color: qrTitleColor || "#007bff",
                fontWeight: "bold",
                fontSize: `${qrTitleSize || 18}pt`,
                marginBottom: "0.4cm",
              }}
            >
              {qrTitle}
            </h4>
          )}
          {qrDesc && (
            <p
              style={{
                color: qrDescColor || "#666666",
                fontSize: `${qrDescSize || 13}pt`,
                marginBottom: "1cm",
              }}
            >
              {qrDesc}
            </p>
          )}
        </div>
        {/* QR Code */}
        <div
          style={{
            position: "relative",
            width: `${qrSizeCm}cm`,
            height: `${qrSizeCm}cm`,
            margin: "0 auto",
            borderRadius: "12px",
            border: `6px solid ${qrTitleColor || "#007bff"}`,
            padding: "0.2cm",
            background: "#fff",
          }}
        >
          <QRCode
            id="qr-code"
            value={surveyLink}
            size={600}
            fgColor={qrCodeSettings.fgColor || "#000000"}
            bgColor={qrCodeSettings.bgColor || "#ffffff"}
            includeMargin={false}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        {/* Scan Me */}
        <div style={{ textAlign: "center", margin: "0.8cm 0" }}>
          <span
            style={{
              fontSize: "14pt",
              fontWeight: "bold",
              color: "#007bff",
            }}
          >
            Scan Me
          </span>
        </div>
        {/* Footer Branding */}
  
      </Card.Body>
    </Card>
  );
};
export default QRPreview;